import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { SendApplicationFormValues } from '../../types';
import Grid from '@mui/material/Grid2';
import { InputField } from 'components/form';
import { formatPhoneInput } from 'formatters';
import { SendOcaLinkSendMethods } from '@trnsact/trnsact-shared-types';
import { TestIds } from 'modules/sendCreditApplication/constants';

export const ContactDetailsSection = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<SendApplicationFormValues>();

  const sendMethod = useWatch({
    control,
    name: 'sendMethod',
  });

  return (
    <Grid container spacing={2} pt={'12px'}>
      <Grid size={{ xs: 12, md: 3 }}>
        <InputField
          label="Business Name"
          control={control}
          name="contactDetails.businessName"
          inputProps={{ variant: 'outlined' }}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 3 }}>
        <InputField
          label="First Name"
          control={control}
          name="contactDetails.firstName"
          inputProps={{
            variant: 'outlined',
            required: true,
            error: !!errors?.contactDetails?.firstName,
            helperText: errors?.contactDetails?.firstName?.message,
          }}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 3 }}>
        <InputField
          label="Last Name"
          control={control}
          name="contactDetails.lastName"
          inputProps={{
            variant: 'outlined',
            required: true,
            error: !!errors?.contactDetails?.lastName,
            helperText: errors?.contactDetails?.lastName?.message,
          }}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 3 }}>
        <InputField
          label="Mobile Phone"
          control={control}
          name="contactDetails.mobilePhone"
          formatter={formatPhoneInput}
          inputProps={{
            variant: 'outlined',
            required: [SendOcaLinkSendMethods.Text, SendOcaLinkSendMethods.TextAndEmail].includes(sendMethod),
            error: !!errors?.contactDetails?.mobilePhone,
            helperText: errors?.contactDetails?.mobilePhone?.message,
            slotProps: { input: { inputProps: { 'data-testid': TestIds.MobilePhoneInput } } },
          }}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 3 }}>
        <InputField
          label="Email"
          control={control}
          name="contactDetails.email"
          inputProps={{
            variant: 'outlined',
            required: [SendOcaLinkSendMethods.Email, SendOcaLinkSendMethods.TextAndEmail].includes(sendMethod),
            error: !!errors?.contactDetails?.email,
            helperText: errors?.contactDetails?.email?.message,
            slotProps: { input: { inputProps: { 'data-testid': TestIds.EmailInput } } },
          }}
        />
      </Grid>
    </Grid>
  );
};
